<template>
  <div id="LoginCallback">
    <div class="loading"></div>
  </div>
</template>

<script>
export default {
  name: 'LoginCallback',
  created () {
    const { code, state } = this.$route.query
    if (!code || !state) {
      this.$Message.error('请先登录！')
      this.$router.push({ name: 'Login' })
    } else {
      this.$store.dispatch('app/getUserInfoInLoginCallback', { code, state })
    }
  },
}
</script>

<style lang="scss">
#LoginCallback {
  .loading {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    background-color: #2d8cf0;
    position: fixed;
    top: 50%;
    left: 50%;
    animation: ani-spin-bounce 1s 0s ease-in-out infinite;
  }
}

@keyframes ani-spin-bounce {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
